import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'next-common-lib';
import i18n from 'i18n';

export const TblRowHeader = ({ rowHeader, isRequired, useTooltip, toolTipBody }) => {
  return (
    <div className="form-title">
      {i18n.t(rowHeader)}
      {isRequired && <sup>*</sup>}
      {useTooltip && (
        <Tooltip componentType="hover" label={[i18n.t(toolTipBody)]} placement="bottom-start">
          <i className="ic_tooltip_info" />
        </Tooltip>
      )}
    </div>
  );
};
TblRowHeader.propTypes = {
  rowHeader: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  useTooltip: PropTypes.bool,
  toolTipBody: PropTypes.string,
};
TblRowHeader.defaultProps = { isRequired: false, useTooltip: false, toolTipBody: '' };
export default TblRowHeader;
